import apis  from "../../api/index";
import {utils} from "../../utils/utils";

export default {
    name: "RoleManage",
    components: {
    },
    data() {
      return {
        query: {
          roleName:'',
          pageIndex: 1,
          pageSize: 10
        },
        pageTotal: 0,
        scrollHeight:250,
        dialogVisibleAdd: false,
        dialogVisibleEdit: false,
        dialogVisibleSet:false,

        size: 'small',
        columns: [
          {prop:"RoleID", label:"角色编号", minWidth:50},
          {prop:"RoleName", label:"角色名称", minWidth:120},
          {prop:"RoleDesc", label:"备注", minWidth:120},
          {prop:"Creator", label:"创建人", minWidth:120},
          {prop:"CreateTime", label:"创建时间", minWidth:120}
        ],
        pageResult: [],
        editLoading: false,
        dataFormRules: {
          name: [
            { required: true, message: '请输入角色名', trigger: 'blur' }
          ]
        },
        // 新增编辑界面数据
        dataForm: {
          RoleID: 0,
          RoleName: '',
          RoleDesc: ''
        },
        menuData: [],
        checkAll: false,
        defaultProps: {
          id:'MenuID',
          label: "MenuName",
          children: "Children"
        },
        checkedMenus:[]
      }
    },
    created() {
    },
    methods: {
      // 获取分页数据
      getTableData() {
        let that = this;
        let queryPara = utils.deepCopy(that.query);
        apis.getRolesByCondition(queryPara).then((res) => {
          that.pageResult = res.resultData
          that.pageTotal = res.totalCount || 0;
        })
      },
      onClearCondtionChange(){
        this.query.roleName = ''
      },
      // 删除角色
      handleDelete(index,row) {
        this.$confirm("您确认删除角色吗？", "提示", {
          type: "warning"
        }).then(() => {
          if(row){
            let params = {
              roleId:row.RoleID
            };
            apis.deleteRole(params).then(res => {
              // -1失败
              // -2不存在
              // -3有子菜单
              if (res===-2) {
                this.$message({
                  message: "删除角色不存在",
                  type: "error"
                });
              } else if(res===-1) {
                this.$message({
                  message: "删除角色失败，请重试",
                  type: "error"
                });
              }else{
                this.getTableData();
                this.$message({ message: "删除角色成功", type: "success" });
              }
            })
          }
        });
      },
      // 显示新增界面
      handleAdd(){
        this.dialogVisibleAdd = true
        this.dataForm = {
          RoleID: 0,
          RoleName: '',
          RoleDesc: ''
        }
      },
      // 显示编辑界面
      handleEdit(index,row) {
        this.dialogVisibleEdit = true
        this.dataForm = Object.assign({}, row)
      },
      // 显示设置权限
      handleSetPerm(index,row){
        let that = this
        that.dataForm = Object.assign({}, row)
        that.dialogVisibleSet = true
        that.checkedMenus = []
        that.getMenuTreeData(function(res){
          that.$nextTick(() => {
            that.$refs.menuTree.setCheckedNodes([])
            let checkedArrayMenus = []
            let roleMenuIdArray = that.dataForm.MenuIds.split(',')
            let menus = that.getMenusNotTree(res)
            for(let i=0;i<roleMenuIdArray.length;i++){
                for(let j=0;j<menus.length;j++){
                  if(roleMenuIdArray[i] + '' === menus[j]['MenuID'] + ''){
                    if(menus[j]['Type'] !== 0){
                      checkedArrayMenus.push(roleMenuIdArray[i])
                      that.$refs.menuTree.setChecked(roleMenuIdArray[i], true)
                    }
                    break
                  }
                }
            }
            // that.$refs.menuTree.setCheckedNodes([])
            // that.checkedMenus = checkedArrayMenus
          });
        })
      },
      //  新增角色
      addRole() {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.$confirm('您确定要添加角色吗？', '提示', {}).then(() => {
              this.editLoading = true
              let params = Object.assign({}, this.dataForm)
              apis.addRole(params).then((res) => {
                this.editLoading = false
                if (res>0) {
                  this.$message.success("添加角色成功");
                  this.$refs["dataForm"].resetFields();
                  this.dialogVisibleAdd = false;
                } else if(res===-2) {
                  this.$message({
                    message: "该角色名已经存在",
                    type: "error"
                  });
                }else{
                  this.$message({
                    message: "添加角色失败",
                    type: "error"
                  });
                }
                this.getTableData(null)
              })
            })
          }
        })
      },
      //  编辑角色
      editRole() {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.$confirm('您确定要修改角色吗？', '提示', {}).then(() => {
              this.editLoading = true
              let params = Object.assign({}, this.dataForm)
              delete params.MenuIds
              apis.updateRole(params).then((res) => {
                this.editLoading = false
                if (res===0) {
                  this.$message.success("修改角色成功");
                  this.$refs["dataForm"].resetFields();
                  this.dialogVisibleEdit = false;
                } else if(res===-2) {
                  this.$message({
                    message: "该角色不经存在",
                    type: "error"
                  });
                }else{
                  this.$message({
                    message: "修改角色失败",
                    type: "error"
                  });
                }
                this.getTableData(null)
              })
            })
          }
        })
      },
      // 获取菜单树数据
      getMenuTreeData(callBack) {
        let para ={
          type:'*',
          pageIndex: 1,
          pageSize: 10000
        }
        apis.getAllMenus(para).then(res => {
          this.menuData = res.resultData;
          if(callBack){
            callBack(res.resultData)
          }
        });
      },
      // 树节点选择监听
      handleMenuCheckChange(data, check) {
        if(check) {
          // 节点选中时同步选中父节点
          let parentId = data.ParentMenuID
          this.$refs.menuTree.setChecked(parentId, true, false)
        } else {
          // 节点取消选中时同步取消选中子节点
          if(data.children != null) {
            data.children.forEach(element => {
              this.$refs.menuTree.setChecked(element.MenuID, false, false)
            });
          }
        }
      },
      // 取消选择
      resetSelection() {
       this.dialogVisibleSet = false
      },
      // 全选操作
      handleCheckAll() {
        if(this.checkAll) {
          let allMenus = []
          this.checkAllMenu(this.menuData, allMenus)
          this.$refs.menuTree.setCheckedNodes(allMenus)
        } else {
          this.$refs.menuTree.setCheckedNodes([])
        }
      },
      // 递归全选
      checkAllMenu(menuData, allMenus) {
        menuData.forEach(menu => {
          allMenus.push(menu)
          if(menu.Children) {
            this.checkAllMenu(menu.Children, allMenus)
          }
        });
      },
      // 角色菜单授权提交
      submitAuthForm() {
        let checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)
        let roleMenus = []
        for(let i=0, len=checkedNodes.length; i<len; i++) {
          roleMenus.push(checkedNodes[i].MenuID)
        }
        let params = {
          RoleID:this.dataForm.RoleID,
          MenuIds:roleMenus.join(',')
        }
        apis.updateRole(params).then((res) => {
          if (res===0) {
            this.$message.success("权限设置成功");
            this.dialogVisibleSet = false;
          } else if(res===-2) {
            this.$message({
              message: "该角色不经存在",
              type: "error"
            });
          }else{
            this.$message({
              message: "权限设置失败",
              type: "error"
            });
          }
          this.getTableData(null)
        })
      },
      renderContent(h, { node, data, store }) {
        return (
        <div class="column-container">
          <span style="text-algin:center;margin-right:15px;">{data.MenuName}</span>
          <span style="text-algin:center;margin-right:15px;">
            <el-tag type={data.Type === 0?'':data.Type === 1?'success':'info'} size="small">
              {data.Type === 0 ? '目录' :data.Type === 1 ? '菜单' : '按钮' }
            </el-tag>
          </span>
        </div>);
      },
      // 动态计算表格高度
      calcTableHeight(){
        this.$nextTick(() => {
          let height = $(".content-box .content").height() - $(".content-box .content .seach-container").height() - 16 - 24 -72
          this.scrollHeight = (height)
        });
      },
      // 页面切换事件
      handlePageChange(val) {
          this.query.pageIndex = val
          this.getTableData()
      },
      // 页码切换事件
      handleSizeChange(val){
          this.query.pageIndex = 1
          this.query.pageSize = val
          this.getTableData()
      },
      // 从树节点读取所有节点
      getMenusNotTree(menus){
        let that = this
        let newMenus = []
        if(menus&&menus.length>0){
          for(let i=0;i<menus.length;i++){
            newMenus.push(menus[i])
            if(menus[i].Children&&menus[i].Children.length>0){
              let menuChild = that.getMenusNotTree(menus[i].Children)
              newMenus = newMenus.concat(menuChild)
            }
          }
        }
        return newMenus
      }
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight()
      }
      that.getTableData()
    },
    watch: {

    },
    activated: function () {
    },

    deactivated: function () {

    },
  };
